class DramaboxUtil {
  constructor() {
    // API base URL - adjust this based on your deployment
    this.apiBaseUrl = import.meta.env.VITE_API_URL || 'https://dinoshortdb.fun/apiadmin';
  }

  async sign(str) {
    try {
      const response = await fetch(`${this.apiBaseUrl}/sign`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ str })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to generate signature');
      }

      return data.signature;
    } catch (err) {
      console.error("[DramaboxUtil] Sign error:", err);
      return null;
    }
  }

  async randomAndroidId() {
    try {
      const response = await fetch(`${this.apiBaseUrl}/sign/android-id`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to generate Android ID');
      }

      return data.androidId;
    } catch (err) {
      console.error("[DramaboxUtil] Android ID error:", err);
      // Fallback to client-side generation
      const randomHex = Array.from(crypto.getRandomValues(new Uint8Array(4)))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
      return "ffffffff" + randomHex + "000000000";
    }
  }

  async generateRandomIP() {
    try {
      const response = await fetch(`${this.apiBaseUrl}/sign/random-ip`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to generate random IP');
      }

      return data.ip;
    } catch (err) {
      console.error("[DramaboxUtil] Random IP error:", err);
      // Fallback to client-side generation
      return Array.from({ length: 4 }, () => Math.floor(Math.random() * 256)).join(".");
    }
  }

  async generateUUID() {
    try {
      const response = await fetch(`${this.apiBaseUrl}/sign/uuid`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Failed to generate UUID');
      }

      return data.uuid;
    } catch (err) {
      console.error("[DramaboxUtil] UUID error:", err);
      // Fallback to client-side generation
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  }
}

export default DramaboxUtil;